export enum SystemFolderNamesEnum {
    assigned = 'Assigned documents',
    tasks = 'Task files',
    training = 'Training files',
    upload = 'Employee uploads',
}
